import React, { useEffect, useState } from 'react';
import { DashboardLayout } from '../Components';
import { supabase } from '../Utils/supabaseClient';

const statusOptions = ['pending', 'reviewed', 'action_taken'];

const Chatreports = () => {
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const [reporterFilter, setReporterFilter] = useState('All');
  const [reportedUserFilter, setReportedUserFilter] = useState('All');
  const [dateFrom, setDateFrom] = useState('');    // <-- added
  const [dateTo, setDateTo] = useState('');        // <-- added

  const fetchReports = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('reports')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('❌ Failed to fetch reports:', error.message);
    } else {
      setReports(data);
      setFilteredReports(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    let filtered = reports;

    if (reporterFilter !== 'All') {
      filtered = filtered.filter(r => r.reporter_id === reporterFilter);
    } else if (reportedUserFilter !== 'All') {
      filtered = filtered.filter(r => r.reported_user_id === reportedUserFilter);
    }

    // Date filtering logic
    if (dateFrom) {
      // Compare only the date parts, ignore time
      filtered = filtered.filter(r =>
        new Date(r.created_at) >= new Date(dateFrom)
      );
    }
    if (dateTo) {
      // To include the entire "to" date, advance by one day
      const toDate = new Date(dateTo);
      toDate.setDate(toDate.getDate() + 1);
      filtered = filtered.filter(r =>
        new Date(r.created_at) < toDate
      );
    }

    setFilteredReports(filtered);
  }, [reporterFilter, reportedUserFilter, dateFrom, dateTo, reports]);

  const updateStatus = async (reportId, newStatus) => {
    const { error } = await supabase
      .from('reports')
      .update({ status: newStatus })
      .eq('id', reportId);

    if (error) {
      console.error('❌ Failed to update status:', error.message);
      alert('Failed to update status');
    } else {
      const updatedReports = reports.map(r =>
        r.id === reportId ? { ...r, status: newStatus } : r
      );
      setReports(updatedReports);
    }
  };

  const uniqueReporters = Array.from(new Set(reports.map(r => r.reporter_id)));
  const uniqueReportedUsers = Array.from(
    new Set(reports.map(r => r.reported_user_id))
  );

  return (
    
      <div style={{ padding: '24px' }}>
        <h2 style={{ marginBottom: '20px' }}>🚨 Chat Reports</h2>

        {/* Filters */}
        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', flexWrap: 'wrap' }}>
          <div>
            <label>Reporter:</label>
            <select
              value={reporterFilter}
              onChange={e => {
                setReporterFilter(e.target.value);
                setReportedUserFilter('All');
              }}
              style={filterSelectStyle}
            >
              <option value="All">All</option>
              {uniqueReporters.map(id => (
                <option key={id} value={id}>
                  {id}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>Reported User:</label>
            <select
              value={reportedUserFilter}
              onChange={e => {
                setReportedUserFilter(e.target.value);
                setReporterFilter('All');
              }}
              style={filterSelectStyle}
            >
              <option value="All">All</option>
              {uniqueReportedUsers.map(id => (
                <option key={id} value={id}>
                  {id}
                </option>
              ))}
            </select>
          </div>
          {/* Date From filter */}
          <div>
            <label htmlFor="date-from">From:</label>
            <input
              type="date"
              id="date-from"
              value={dateFrom}
              onChange={e => setDateFrom(e.target.value)}
              style={filterSelectStyle}
            />
          </div>
          {/* Date To filter */}
          <div>
            <label htmlFor="date-to">To:</label>
            <input
              type="date"
              id="date-to"
              value={dateTo}
              onChange={e => setDateTo(e.target.value)}
              style={filterSelectStyle}
            />
          </div>
          {/* Optional: Add a clear all filters button */}
          {(dateFrom || dateTo || reporterFilter !== 'All' || reportedUserFilter !== 'All') && (
            <button
              onClick={() => {
                setDateFrom('');
                setDateTo('');
                setReporterFilter('All');
                setReportedUserFilter('All');
              }}
              style={{
                ...filterSelectStyle,
                background: '#eee',
                border: '1px solid #999',
                cursor: 'pointer',
              }}
            >
              Clear Filters
            </button>
          )}
        </div>

        {loading ? (
          <p>Loading reports...</p>
        ) : filteredReports.length === 0 ? (
          <p>No reports found.</p>
        ) : (
          <table style={tableStyle}>
            <thead style={{ background: '#f5f5f5' }}>
              <tr>
                <th style={thStyle}>Reporter</th>
                <th style={thStyle}>Reported User</th>
                <th style={thStyle}>Reason</th>
                <th style={thStyle}>Extra Notes</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Submitted At</th>
              </tr>
            </thead>
            <tbody>
              {filteredReports.map(report => (
                <tr key={report.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={tdStyle}>{report.reporter_id}</td>
                  <td style={tdStyle}>{report.reported_user_id}</td>
                  <td style={tdStyle}>{report.reason}</td>
                  <td style={tdStyle}>{report.extra_notes || '-'}</td>
                  <td style={tdStyle}>
                    <select
                      value={report.status}
                      onChange={e => updateStatus(report.id, e.target.value)}
                      style={{
                        padding: '6px 10px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                      }}
                    >
                      {statusOptions.map(opt => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td style={tdStyle}>
                    {new Date(report.created_at).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    
  );
};


// ----- Styles -----
const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  background: '#fff',
  border: '1px solid #ccc',
  borderRadius: '8px',
  overflow: 'hidden',
};
const thStyle = {
  padding: '10px',
  textAlign: 'left',
  fontWeight: 'bold',
  borderBottom: '1px solid #ddd',
};
const tdStyle = {
  padding: '10px',
  fontSize: '14px',
  verticalAlign: 'top',
};
const filterSelectStyle = {
  marginLeft: '8px',
  padding: '6px 10px',
  borderRadius: '4px',
  border: '1px solid #ccc',
};

export { Chatreports };
